module.exports = __webpack_public_path__ + "img/human-capital-management.cc75fdc6.png";